/**
* @license Xpo Logistics v${_cBuilderVersion}
 * Copyright (c) 2017 Xpo Logistics, Inc. http://www.http://xpo-1.com/
 * License: MIT
 */
import { ChangeDetectionStrategy, Component, Injectable, InjectionToken, Input, NgModule, Optional, SkipSelf, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Observable, Subject } from 'rxjs/Rx';
import { Log, UserManager } from 'oidc-client';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpClient, HttpHeaders } from '@angular/common/http';
var XpoCoreModule = (function () {
    function XpoCoreModule() {
    }
    return XpoCoreModule;
}());
XpoCoreModule.decorators = [
    { type: NgModule, args: [{
                imports: [],
                exports: [],
                providers: [],
            },] },
];
/** @nocollapse */
XpoCoreModule.ctorParameters = function () { return []; };
/**
 * <xpo-example> component displays example content.  This is an example component used as a template for other components.
 */
var XPOExample = (function () {
    /** This is the constructor which injects the service and subscribed to
     * the config cryer to set information when it is changed
     * */
    function XPOExample() {
    }
    Object.defineProperty(XPOExample.prototype, "helper", {
        /** The example helper. */
        get: function () { return this.helperObj; },
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XPOExample;
}());
XPOExample.decorators = [
    { type: Component, args: [{ selector: 'xpo-example',
                host: {},
                template: "<span *ngIf=\"helperObj\"> {{ helperObj.value }} </span> <ng-content></ng-content> <br> <h4>Variable from the XPO Config</h4> Layout: {{ tmpCfg.layout }}<br><br>",
                styles: [" /*# sourceMappingURL=example.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/** @nocollapse */
XPOExample.ctorParameters = function () { return []; };
XPOExample.propDecorators = {
    'helper': [{ type: Input },],
};
var XpoExampleModule = (function () {
    function XpoExampleModule() {
    }
    /** @deprecated */
    XpoExampleModule.forRoot = function () {
        return {
            ngModule: XpoExampleModule,
        };
    };
    return XpoExampleModule;
}());
XpoExampleModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XPOExample],
                declarations: [XPOExample],
            },] },
];
/** @nocollapse */
XpoExampleModule.ctorParameters = function () { return []; };
var UserDetail = (function () {
    function UserDetail(profile, accessToken, tokenType) {
        var _this = this;
        this.profile = profile;
        this.claims = [];
        this.userName = this.getClaim('sub').value;
        this.firstName = this.getClaim('given_name').value;
        this.lastName = this.getClaim('family_name').value || this.getClaim('surname').value;
        this.email = this.getClaim('email').value;
        this.name = this.getClaim('name').value;
        this.role = this.getClaim('role').value;
        this.accessToken = accessToken;
        this.tokenType = tokenType;
        Object.keys(profile).forEach(function (value) {
            _this.claims.push(new Claim(value, profile[value]));
        });
    }
    UserDetail.prototype.getClaim = function (type) {
        if (this.profile.hasOwnProperty(type)) {
            return new Claim(type, this.profile[type]);
        }
        return new Claim(type, '');
    };
    return UserDetail;
}());
var Claim = (function () {
    function Claim(type, value) {
        this.type = type;
        this.value = value;
    }
    return Claim;
}());
var SECURITY_CONFIG = new InjectionToken("security.config");
var SecurityServiceConfig = (function () {
    function SecurityServiceConfig(params) {
        this.baseScopes = ['openid', 'email', 'name', 'xpo-auth-api'];
        this.baseResponseTypes = ['id_token', 'token'];
        this.appCode = params.appCode;
        this.authorityUri = params.authorityUri.endsWith('/') ? params.authorityUri.substring(0, params.authorityUri.lastIndexOf('/')) : params.authorityUri;
        this.applicationRootUri = params.applicationRootUri.endsWith('/') ? params.applicationRootUri : params.applicationRootUri + '/';
        this.enableLogging = params.enableLogging || false;
        if (params.unauthorizedPath === undefined) {
            this.unauthorizedPath = '/unauthorized';
        }
        else {
            this.unauthorizedPath = params.unauthorizedPath;
        }
        this.scopes = this.distinct(this.baseScopes.concat(params.scopes || [])).join(' ');
        this.responseTypes = this.distinct(this.baseResponseTypes.concat(params.responseTypes || [])).join(' ');
        this.authApiBasePath = params.authApiBasePath;
    }
    SecurityServiceConfig.prototype.distinct = function (items) {
        return items.filter(function (value, index, list) {
            return index == list.indexOf(value);
        });
    };
    Object.defineProperty(SecurityServiceConfig.prototype, "value", {
        get: function () {
            return {
                authority: this.authorityUri,
                client_id: this.appCode,
                redirect_uri: this.applicationRootUri + 'auth',
                post_logout_redirect_uri: this.applicationRootUri + 'postsignout',
                response_type: this.responseTypes,
                scope: this.scopes,
                silent_redirect_uri: this.applicationRootUri + 'authsilent',
                automaticSilentRenew: true,
                filterProtocolClaims: true,
                loadUserInfo: true,
                enableLogging: this.enableLogging,
                unauthorizedPath: this.unauthorizedPath,
                authApiBasePath: this.authApiBasePath
            };
        },
        enumerable: true,
        configurable: true
    });
    return SecurityServiceConfig;
}());
var STORAGE_URL_KEY = 'xpo-pre-login-route';
var SecurityService = (function () {
    /**
     *
     */
    function SecurityService(router, config) {
        var _this = this;
        this.router = router;
        this.isAuthenticated = false;
        this.isAuthorized = false;
        this.userSubject = new BehaviorSubject(undefined);
        this.user = this.userSubject.asObservable();
        this.postSignoutEvent = new Subject();
        this.config = config.value;
        var userManagerSettings = {
            authority: this.config.authority,
            client_id: this.config.client_id,
            redirect_uri: this.config.redirect_uri,
            post_logout_redirect_uri: this.config.post_logout_redirect_uri,
            response_type: this.config.response_type,
            scope: this.config.scope,
            silent_redirect_uri: this.config.silent_redirect_uri,
            automaticSilentRenew: this.config.automaticSilentRenew,
            filterProtocolClaims: this.config.filterProtocolClaims,
            loadUserInfo: this.config.loadUserInfo
        };
        this.mgr = new UserManager(userManagerSettings);
        this.mgr.events.addUserLoaded(function (user) {
            _this.log("oidc UserLoaded event", user);
            var userDetail = new UserDetail(user.profile, user.access_token, user.token_type);
            _this.userSubject.next(userDetail);
        });
        this.mgr.events.addUserUnloaded(function (e) {
            _this.log("user unloaded");
            _this.isAuthenticated = false;
            _this.isAuthorized = false;
        });
        if (this.config.enableLogging) {
            Log.logger = console;
        }
    }
    SecurityService.GetInstance = function (router, config) {
        if (SecurityService.instance == null) {
            SecurityService.instance = new SecurityService(router, config);
        }
        return SecurityService.instance;
    };
    /**
     * Public methods
     */
    SecurityService.prototype.beginSignIn = function (redirectUrl, data) {
        var _this = this;
        this.log("beginSignIn");
        if (redirectUrl)
            sessionStorage.setItem(STORAGE_URL_KEY, redirectUrl);
        this.mgr.signinRedirect(data || {}).then(function () {
            _this.log("signinRedirect done");
        }).catch(function (err) {
            _this.logError(err);
        });
    };
    SecurityService.prototype.logIn = function () {
        var _this = this;
        var signIn = Observable.fromPromise(this.mgr.signinRedirectCallback());
        signIn.subscribe(function (user) {
            _this.log('SecurityService - signIn - signinRedirectCallback', user);
            _this.isAuthenticated = true;
            _this.isAuthorized = user != null;
            var routeUrl = sessionStorage.getItem(STORAGE_URL_KEY) || '/';
            sessionStorage.removeItem(STORAGE_URL_KEY);
            _this.router.navigate([routeUrl]);
        });
    };
    SecurityService.prototype.silentRefresh = function () {
        this.log("SecurityService - silentRefresh");
        this.mgr.signinSilentCallback();
    };
    SecurityService.prototype.signOut = function () {
        var _this = this;
        this.clearState().then(function () {
            _this.startSignoutMainWindow();
        });
        this.isAuthenticated = false;
        this.isAuthorized = false;
        this.userSubject.next(undefined);
    };
    SecurityService.prototype.clearState = function () {
        var _this = this;
        return this.mgr.clearStaleState().then(function () {
            _this.log("clearStateState success");
        }).catch(function (e) {
            _this.logError("clearStateState error", e.message);
        });
    };
    SecurityService.prototype.startSignoutMainWindow = function () {
        var _this = this;
        this.mgr.signoutRedirect().then(function (resp) {
            _this.log("signed out", resp);
        }).catch(function (err) {
            _this.logError(err);
        });
    };
    ;
    SecurityService.prototype.endSignoutMainWindow = function () {
        var _this = this;
        this.mgr.signoutRedirectCallback().then(function (resp) {
            _this.log("signed out", resp);
            _this.postSignoutEvent.next(null);
        }).catch(function (err) {
            _this.logError(err);
        });
    };
    ;
    SecurityService.prototype.log = function (message) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        if (this.config.enableLogging == false) {
            return;
        }
        if (params) {
            console.log(message, params);
        }
        else {
            console.log(message);
        }
    };
    SecurityService.prototype.logError = function (message, params) {
        if (this.config.enableLogging == false) {
            return;
        }
        if (params) {
            console.error(message, params);
        }
        else {
            console.error(message);
        }
    };
    return SecurityService;
}());
SecurityService.instance = null;
SecurityService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
SecurityService.ctorParameters = function () { return [
    { type: Router, },
    { type: SecurityServiceConfig, },
]; };
var AuthComponent = (function () {
    function AuthComponent(securityService, router) {
        this.securityService = securityService;
        this.router = router;
    }
    AuthComponent.prototype.ngOnInit = function () {
        console.log('AuthComponent - ngOnInit');
        if (this.securityService.isAuthenticated) {
            this.router.navigate(['/']);
        }
        else {
            this.securityService.logIn();
        }
    };
    return AuthComponent;
}());
AuthComponent.decorators = [
    { type: Component, args: [{
                selector: 'xpo-authentication',
                template: ''
            },] },
];
/** @nocollapse */
AuthComponent.ctorParameters = function () { return [
    { type: SecurityService, },
    { type: Router, },
]; };
var AuthSilentComponent = (function () {
    function AuthSilentComponent(securityService) {
        this.securityService = securityService;
    }
    AuthSilentComponent.prototype.ngOnInit = function () {
        this.securityService.silentRefresh();
    };
    return AuthSilentComponent;
}());
AuthSilentComponent.decorators = [
    { type: Component, args: [{
                selector: 'xpo-authentication-silent',
                template: ''
            },] },
];
/** @nocollapse */
AuthSilentComponent.ctorParameters = function () { return [
    { type: SecurityService, },
]; };
var UnauthorizedComponent = (function () {
    function UnauthorizedComponent() {
    }
    UnauthorizedComponent.prototype.ngOnInit = function () {
    };
    return UnauthorizedComponent;
}());
UnauthorizedComponent.decorators = [
    { type: Component, args: [{
                selector: 'xpo-unauthorized',
                template: "<h2>You are not authorized to access this application!</h2>"
            },] },
];
/** @nocollapse */
UnauthorizedComponent.ctorParameters = function () { return []; };
var PostSignoutComponent = (function () {
    function PostSignoutComponent(securityService) {
        this.securityService = securityService;
    }
    PostSignoutComponent.prototype.ngOnInit = function () {
        this.securityService.endSignoutMainWindow();
    };
    return PostSignoutComponent;
}());
PostSignoutComponent.decorators = [
    { type: Component, args: [{
                selector: 'xpo-postsignout',
                template: ''
            },] },
];
/** @nocollapse */
PostSignoutComponent.ctorParameters = function () { return [
    { type: SecurityService, },
]; };
var AuthGuardService = (function () {
    function AuthGuardService(securityService, router) {
        this.securityService = securityService;
        this.router = router;
    }
    /**
     * Checks whether the user canActive a route
     */
    AuthGuardService.prototype.canActivate = function (route, state) {
        if (this.securityService.isAuthenticated) {
            if (this.securityService.isAuthorized) {
                return true;
            }
            else {
                this.notAuthorized();
                return false;
            }
        }
        this.securityService.beginSignIn(state.url);
    };
    AuthGuardService.prototype.notAuthorized = function () {
        var path = this.securityService.config.unauthorizedPath;
        if (path !== null)
            this.router.navigate([path]);
    };
    return AuthGuardService;
}());
AuthGuardService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
AuthGuardService.ctorParameters = function () { return [
    { type: SecurityService, },
    { type: Router, },
]; };
var routes = [
    {
        path: 'auth',
        component: AuthComponent,
    },
    {
        path: 'authsilent',
        component: AuthSilentComponent,
    },
    {
        path: 'unauthorized',
        component: UnauthorizedComponent
    },
    {
        path: 'postsignout',
        component: PostSignoutComponent
    }
];
var XpoSecurityRoutingModule = (function () {
    function XpoSecurityRoutingModule() {
    }
    return XpoSecurityRoutingModule;
}());
XpoSecurityRoutingModule.decorators = [
    { type: NgModule, args: [{
                imports: [RouterModule.forChild(routes)],
                exports: [RouterModule],
            },] },
];
/** @nocollapse */
XpoSecurityRoutingModule.ctorParameters = function () { return []; };
var securityServiceFactory = function (router, config) {
    return SecurityService.GetInstance(router, config);
};
var securityServiceProvider = {
    provide: SecurityService,
    deps: [Router, SECURITY_CONFIG],
    useFactory: securityServiceFactory
};
var profileServiceFactory = function (httpClient, config) {
    return new AuthUserProfileService(httpClient, config);
};
var AuthUserProfileService = (function () {
    function AuthUserProfileService(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        if (this.config.value) {
            this.basePath = config.value.authApiBasePath || this.basePath;
        }
    }
    /**
     * Get Profile
     *
     * @param clientId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    AuthUserProfileService.prototype.getProfile = function (clientId) {
        if (clientId === null || clientId === undefined) {
            throw new Error('Required parameter clientId was null or undefined when calling getProfile.');
        }
        var headers = this.defaultHeaders;
        var httpHeaderAccepts = [
            'application/json'
        ];
        headers = headers.set("Accept", httpHeaderAccepts);
        return this.httpClient.get(this.basePath + "/profile/" + encodeURIComponent(String(clientId)), {
            withCredentials: true,
            headers: headers
        });
    };
    return AuthUserProfileService;
}());
AuthUserProfileService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
AuthUserProfileService.ctorParameters = function () { return [
    { type: HttpClient, },
    { type: SecurityServiceConfig, },
]; };
var profileServiceProvider = {
    provide: AuthUserProfileService,
    deps: [HttpClient, SECURITY_CONFIG],
    useFactory: profileServiceFactory
};
var AUTH_HEADER_KEY = 'Authorization';
var AuthHttpInterceptor = (function () {
    /**
     *
     */
    function AuthHttpInterceptor(securityService) {
        var _this = this;
        this.securityService = securityService;
        this.securityService.user
            .subscribe(function (userDetail) { return _this.onUserChanged(userDetail); });
    }
    AuthHttpInterceptor.prototype.intercept = function (request, next) {
        if (this.authHeaderValue) {
            var authRequest = request.clone({
                headers: request.headers.set(AUTH_HEADER_KEY, this.authHeaderValue)
            });
            return next.handle(authRequest);
        }
        else {
            return next.handle(request);
        }
    };
    AuthHttpInterceptor.prototype.onUserChanged = function (userDetail) {
        if (!userDetail) {
            this.clearBearerToken();
        }
        else {
            this.setBearerToken(userDetail);
        }
    };
    AuthHttpInterceptor.prototype.clearBearerToken = function () {
        this.authHeaderValue = undefined;
    };
    AuthHttpInterceptor.prototype.setBearerToken = function (userDetail) {
        this.clearBearerToken();
        if (userDetail.accessToken) {
            this.authHeaderValue = (userDetail.tokenType || 'Bearer') + " " + userDetail.accessToken;
        }
    };
    return AuthHttpInterceptor;
}());
AuthHttpInterceptor.decorators = [
    { type: Injectable },
];
/** @nocollapse */
AuthHttpInterceptor.ctorParameters = function () { return [
    { type: SecurityService, },
]; };
var XpoSecurityModule = (function () {
    function XpoSecurityModule(existingModule) {
        // Stops multi loading of the module into lazy-loaded modules
        if (existingModule) {
            throw new Error('XpoSecurityModule is already loaded. Import it in the AppModule only');
        }
    }
    return XpoSecurityModule;
}());
XpoSecurityModule.decorators = [
    { type: NgModule, args: [{
                imports: [XpoSecurityRoutingModule],
                exports: [],
                declarations: [AuthComponent, AuthSilentComponent, UnauthorizedComponent, PostSignoutComponent],
                providers: [
                    securityServiceProvider,
                    AuthGuardService,
                    profileServiceProvider
                ],
            },] },
];
/** @nocollapse */
XpoSecurityModule.ctorParameters = function () { return [
    { type: XpoSecurityModule, decorators: [{ type: Optional }, { type: SkipSelf },] },
]; };
/* tslint:disable */
var packageModules = [
    XpoCoreModule,
    XpoExampleModule,
    XpoSecurityModule
];
/** @deprecated */
var XpoSecurityLibrary = (function () {
    function XpoSecurityLibrary() {
    }
    return XpoSecurityLibrary;
}());
XpoSecurityLibrary.decorators = [
    { type: NgModule, args: [{
                imports: packageModules,
                exports: packageModules,
            },] },
];
/** @nocollapse */
XpoSecurityLibrary.ctorParameters = function () { return []; };
/**
 * @module
 * @description
 * Entry point for all public APIs of xpo-builder.
 */
/* tslint:disable */
/* tslint:enable */
/**
 * Generated bundle index. Do not edit.
 */
export { profileServiceFactory as ɵb, profileServiceProvider as ɵc, securityServiceFactory as ɵa, XpoSecurityRoutingModule as ɵd, XpoCoreModule, XpoSecurityLibrary, XpoExampleModule, XPOExample, XpoSecurityModule, SecurityServiceConfig, SECURITY_CONFIG, UserDetail, SecurityService, AuthGuardService, AuthSilentComponent, AuthComponent, UnauthorizedComponent, securityServiceProvider, AuthHttpInterceptor, PostSignoutComponent, AuthUserProfileService };



//////////////////
// WEBPACK FOOTER
// /ng-app/node_modules/@xpo/security/@xpo/xpo-security.es5.js
// module id = ../../../../@xpo/security/@xpo/xpo-security.es5.js
// module chunks = vendor